import { LearnMoreItem } from "../../items";
import { Card } from "../Card";
import { GridStyled } from "./styles";

interface GridProps {
	items: LearnMoreItem[];
}

export const Grid = ({ items }: GridProps) => {
	return (
		<GridStyled>
			{items.map((item, key) => (
				<Card item={item} key={key} />
			))}
		</GridStyled>
	);
};
